import { FC, useContext } from 'react';
import styled from 'styled-components';
import { darken, IconButton, Tooltip } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { IntroModulesContext } from './IntroModulesContext';

const BackButton = styled(IconButton)`
  position: absolute;
  left: ${({ theme }) => theme.spacing(2)};
  top: ${({ theme }) => theme.spacing(2)};
  z-index: 10;
  background-color: ${({ theme }) => theme.palette.common.white};
  box-shadow: ${({ theme }) => theme.shadows[2]};
  color: ${({ theme }) => theme.palette.text.primary};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => darken(theme.palette.common.white, 0.1)};
  }
`;

const IntroModulesBackButton: FC = () => {
  const { goToPreviousModule, canGoToPreviousModule } =
    useContext(IntroModulesContext);

  if (!canGoToPreviousModule) return null;

  return (
    <Tooltip title="Back" arrow placement="top" enterDelay={1000}>
      <BackButton onClick={goToPreviousModule}>
        <ArrowBack color="primary" />
      </BackButton>
    </Tooltip>
  );
};

export default IntroModulesBackButton;
